import { format } from 'd3-format';
import { Controller } from 'stimulus';

import { parseInteger } from '../models/helpers';

export default class extends Controller {
  static targets = [
    'subAccountContributionContainer',
    'contributionEstimate',
    'contributionOverrideInput',
    'annualAutomaticDeposit',
    'totalContributions',
    'baseError',
  ];

  totalContributionsTarget: HTMLElement;

  contributionEstimateTargets: HTMLElement[];

  contributionOverrideInputTargets: HTMLInputElement[];

  subAccountContributionContainerTargets: HTMLElement[];

  baseErrorTarget: HTMLElement;

  connect() {
    this.updateTotalContributions();
  }

  refresh() {
    this.updateTotalContributions();
    this.hideBaseError();
  }

  updateTotalContributions() {
    this.totalContributionsTarget.textContent = format('$,.0f')(this.getTotalContributions());
  }

  getTotalContributions() {
    return this.getTotalEstimates() + this.getTotalOverrides();
  }

  getTotalEstimates() {
    return this.contributionEstimateTargets
      .map(estimateTarget => {
        const overrideInputTarget = this.contributionOverrideInputTargets.find(
          t => t.dataset.subAccountId === estimateTarget.dataset.subAccountId
        );

        if (overrideInputTarget && overrideInputTarget.value === '') {
          return parseInteger(estimateTarget.dataset.amountCents!) / 100;
        }
        return 0;
      })
      .reduce((sum, value) => sum + value);
  }

  getTotalOverrides() {
    return this.contributionOverrideInputTargets
      .map(inputTarget => {
        return parseInteger(inputTarget.value) || 0;
      })
      .reduce((sum, value) => sum + value);
  }

  toggleOverride(e: Event) {
    e.preventDefault();

    const el = e.currentTarget as HTMLElement;
    const containerTarget = this.subAccountContributionContainerTargets.find(
      t => t.dataset.subAccountId === el.dataset.subAccountId
    );

    if (containerTarget) {
      containerTarget.classList.toggle('is-overridden');
    }
  }

  resetOverride(e: Event) {
    e.preventDefault();

    const el = e.currentTarget as HTMLElement;
    const overrideInputTarget = this.contributionOverrideInputTargets.find(
      t => t.dataset.subAccountId === el.dataset.subAccountId
    );

    if (overrideInputTarget) {
      overrideInputTarget.value = '';
    }

    this.updateTotalContributions();
    this.hideBaseError();
  }

  hideBaseError() {
    this.baseErrorTarget.classList.add('u-displayNone');
  }
}
